import { NgModule } from '@angular/core';
import { BrowserModule, provideClientHydration } from '@angular/platform-browser';

import { AppRoutingModule } from './app-routing.module';
import { AppComponent } from './app.component';
import { provideHttpClient, withFetch } from "@angular/common/http";
import { FormsModule } from "@angular/forms";
import { NgOptimizedImage } from "@angular/common";
import { FooterComponent } from "./components/footer/footer.component";
import { SmallHeaderComponent } from "./sites/small-header/small-header.component";
import { TeamActionComponent } from "./components/team-action/team-action.component";
import { MenuComponent } from "./components/menu/menu.component";

@NgModule({
  declarations: [
    AppComponent
  ],
  imports: [
    BrowserModule,
    AppRoutingModule,
    FormsModule,
    NgOptimizedImage,
    FooterComponent,
    SmallHeaderComponent,
    TeamActionComponent,
    MenuComponent
  ],
  providers: [
    provideHttpClient(withFetch()),
    provideClientHydration(),
  ],
  bootstrap: [AppComponent]
})
export class AppModule { }
